import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { BlobResponse } from "../../../models/report";
import { EntCompanyWarehousesFilter } from "../../../models/filters/companyWarehousesFilter";
import { EntCompanyWarehouses } from "../../../models/chemicalization/companyWarehouses";
import { EntCompanyWarehousesReportPayload } from "../../../models/filters/companyWarehousesReportFilter";
import { Paths } from "../../../paths";

export const companyWarehousesApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

	getCompanyWarehousesList: builder.query<ResponseDataGet<EntCompanyWarehouses>, EntCompanyWarehousesFilter>({
	  query: (filter) => ({
		url: `${Paths.chemicalization.company_warehouses}/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getCompanyWarehousesById: builder.query<ResponseDataTest<EntCompanyWarehouses>, number>({
	  query: (id) => ({
		url: `${Paths.chemicalization.company_warehouses}/${ id }`,
		method: 'GET'
	  })
	}),
	addCompanyWarehouses: builder.mutation<ResponseDataTest<EntCompanyWarehouses>, EntCompanyWarehouses>({
	  query: (body) => ({
		url: `${Paths.chemicalization.company_warehouses}`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editCompanyWarehouses: builder.mutation<ResponseDataTest<EntCompanyWarehouses>, EntCompanyWarehouses>({
	  query: (body,) => ({
		url: `${Paths.chemicalization.company_warehouses}`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteCompanyWarehouses: builder.mutation<ResponseDataTest<EntCompanyWarehouses>, number>({
	  query: (id) => ({
		url: `${Paths.chemicalization.company_warehouses}/${ id }`,
		method: 'DELETE',
	  }),
	}),
	reportCompanyWarehouses: builder.mutation<BlobResponse, EntCompanyWarehousesReportPayload>({
	  query: (payload) => {
		const { year, language } = payload;

		return {
		  url: `/departments/chemicalization/report/warehouse`,
		  method: "POST",
		  params: {
			year,
			language
		  },
		  body: JSON.stringify(payload),
		  responseHandler: (response) => response.blob(),
		};
	  },
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddCompanyWarehousesMutation,
  useDeleteCompanyWarehousesMutation,
  useEditCompanyWarehousesMutation,
  useLazyGetCompanyWarehousesListQuery,
  useReportCompanyWarehousesMutation
} = companyWarehousesApi;
